"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationMembersFileName = void 0;
/**
 * Names an organization members export after the organization and the UTC date it was taken, so a
 * reviewer collecting these every quarter can tell two exports apart without opening them. UTC
 * matches the dates written inside the file, so the name and the contents never disagree.
 */
const organizationMembersFileName = (organizationName, exportedOn) => {
    const slug = organizationName
        // Decompose accents so `Société` slugs to `societe` rather than losing the letters to hyphens.
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'organization';
    return `${slug}-members-${exportedOn.toISOString().slice(0, 10)}.csv`;
};
exports.organizationMembersFileName = organizationMembersFileName;
